module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("Spouse Calls: Messages From a Military Life © 2014 by Terri L. Barnes ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("All rights reserved. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-3"
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("Columns in this collection first appeared in ")]), _c('span', {
    staticClass: "Text-Copyright CharOverride-7"
  }, [_vm._v("Stars and Stripes")]), _c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v(". Column dates varied by edition; the dates used in this book reflect the earliest date the column appeared in print or online.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-3"
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("Cover design by Connie DeFlorin and Andermax Studios. Photos courtesy of Terri Barnes, Minnesota National Guard, and Karen Pavlicin-Fragnito. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-3"
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("Terri’s lifelong dream to become an author began in junior high, with her first story attempts pecked out at her grandmother’s house on the typewriter featured on the front cover.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-3"
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-4"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("Barnes, Terri, 1963-")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("  Spouse calls : messages from a military life / Terri Barnes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("       pages cm")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("  ISBN 978-1-934617-25-0 (pb) -- ISBN 978-1-934617-26-7 (epub ebook) -- ISBN 978-1-934617-27-4 (kindle ebook)")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("1.  Barnes, Terri, 1963- 2.  Military spouses--United ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("States--Biography--Anecdotes. 3.  United States--Armed Forces--Military life--Anecdotes.  I. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("  U766.B35 2014")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("  355.0092--dc23")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  }, [_vm._v("  [B]")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-8"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-3"
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("Elva Resa Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("8362 Tamarack Vlg., Ste. 119-106, St. Paul, MN 55125")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-4"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ElvaResa.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("www.ElvaResa.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.MilitaryFamilyBooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("www.MilitaryFamilyBooks.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.SpouseCalls.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Text-Copyright _idGenCharOverride-1"
  }, [_vm._v("www.SpouseCalls.com")])])])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "Text-copyright ParaOverride-5",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-7"
  }, [_vm._v("This book is dedicated to ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-5"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-7"
  }, [_vm._v("Mark, who is my very own military hero;")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-5"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-7"
  }, [_vm._v("our children, Will, Jessie, and Wesley;")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-5"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-7"
  }, [_vm._v("and Mom, who first showed me what being a military wife is all about.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-5"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-7"
  }, [_vm._v("In memory of my father, MSgt. Jimmie L. Hurley, USAF (Ret.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-copyright ParaOverride-5"
  }, [_c('span', {
    staticClass: "Text-Copyright CharOverride-7"
  }, [_vm._v("1941-2009")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e2abf43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spousecalls1.vue
// module id = 60
// module chunks = 0